import { render, staticRenderFns } from "./RemainAmountInfo.vue?vue&type=template&id=29b78660&scoped=true&"
import script from "./RemainAmountInfo.vue?vue&type=script&lang=js&"
export * from "./RemainAmountInfo.vue?vue&type=script&lang=js&"
import style0 from "./RemainAmountInfo.vue?vue&type=style&index=0&id=29b78660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b78660",
  null
  
)

export default component.exports